/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Ipc_MissingInputs */



/**
* | output |
* | --- |
* | "System and Word spell check require the desktop application." |
*
* @param {Spellcheck_Ipc_MissingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_ipc_missing = /** @type {((inputs?: Spellcheck_Ipc_MissingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Ipc_MissingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les moteurs Systeme et Word necessitent l'application de bureau.")
	if (locale === "de") return /** @type {LocalizedString} */ ("System- und Word-Rechtschreibpruefung erfordern die Desktop-Anwendung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I motori Sistema e Word richiedono l'applicazione desktop.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Системная проверка и Word доступны только в настольном приложении.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los motores Sistema y Word requieren la aplicacion de escritorio.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("系统和 Word 拼写检查需要桌面应用程序。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("システムおよび Word のスペルチェックにはデスクトップアプリが必要です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिस्टम और Word वर्तनी जाँच के लिए डेस्कटॉप ऐप आवश्यक है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os motores Sistema e Word requerem a aplicacao de ambiente de trabalho.")
	return /** @type {LocalizedString} */ ("System and Word spell check require the desktop application.")
});